import React, { useState } from "react";
import Page from "../../organisms/Page";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import { Row, Col, Card, Form, Button, Spinner } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";
import styled from "styled-components";
import {
  useDescargarDescuentosPorMes,
  useObtenerDescuentosPorMes,
  DescuentoPorMes,
} from "../../../services/analisisFinanzas";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { obtenerStringDeFecha } from "../../../utils/dateUtils";
import { downloadBlob } from "../../../utils/downloadUtils";
import DescuentosPorMesChart from "./DescuentosPorMesChart";

const breadCrumbs: BreadCrumbItem[] = [
  { path: "/", label: "Inicio" },
  { path: "/analisis", label: "Análisis" },
  { path: "/analisis/finanzas", label: "Finanzas" },
  {
    path: "/analisis/finanzas/descuentos-por-mes",
    label: "Descuentos por mes",
    isActive: true,
  },
];

function DescuentosPorMes() {
  const [fechaInicio, setFechaInicio] = useState<string>(() => {
    const fecha = new Date();
    fecha.setDate(1);
    fecha.setMonth(fecha.getMonth() - 11);
    return obtenerStringDeFecha(fecha);
  });

  const [fechaFin, setFechaFin] = useState<string>(() => {
    return obtenerStringDeFecha(new Date());
  });

  const { data, isLoading, error } = useObtenerDescuentosPorMes(
    fechaInicio,
    fechaFin
  );
  const descargaDescuentosMutacion = useDescargarDescuentosPorMes();

  const descuentosPorMes: DescuentoPorMes[] = data || [];

  const descargarExcel = async () => {
    const respuesta = await descargaDescuentosMutacion.mutateAsync({
      fechaInicio,
      fechaFin,
    });
    const nombreArchivo = respuesta.nombre
      ? `${respuesta.nombre}${
          respuesta.extension ? `.${respuesta.extension}` : ""
        }`
      : `descuentos_por_mes_${fechaInicio}_a_${fechaFin}.xlsx`;
    downloadBlob(respuesta.contenido, nombreArchivo);
  };

  if (error) {
    return <ServerErrorModal />;
  }

  return (
    <Page
      title="Descuentos por mes"
      description="Análisis de descuentos agrupados por mes."
      breadCrumbs={breadCrumbs}
    >
      <LoadingScreen isLoading={isLoading} />
      <Row className="justify-content-center">
        <Col xs={12} md={12} lg={11} xxl={10}>
          <StyledCard>
            <Card.Body>
              <Row className="mb-3">
                <Col xs={12} md={4}>
                  <Form.Group controlId="fechaInicio">
                    <Form.Label>Fecha inicio</Form.Label>
                    <Form.Control
                      type="date"
                      value={fechaInicio}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setFechaInicio(e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group controlId="fechaFin">
                    <Form.Label>Fecha fin</Form.Label>
                    <Form.Control
                      type="date"
                      value={fechaFin}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setFechaFin(e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4} className="d-flex align-items-end">
                  <Button
                    variant="primary"
                    onClick={descargarExcel}
                    disabled={descargaDescuentosMutacion.isLoading}
                  >
                    {descargaDescuentosMutacion.isLoading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Descargando...
                      </>
                    ) : (
                      <>
                        <DownloadIcon sx={{ fontSize: 20, marginRight: "8px" }} />
                        Descargar
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
              {!isLoading && (
                <DescuentosPorMesChart descuentosPorMes={descuentosPorMes} />
              )}
            </Card.Body>
          </StyledCard>
        </Col>
      </Row>
    </Page>
  );
}

const StyledCard = styled(Card)`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export default DescuentosPorMes;
